import React from "react";
import { useNavigate } from "react-router-dom";
import { Globe, ShieldAlert } from "lucide-react";

export default function RegionBlocked() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center p-6" data-testid="region-blocked-page">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto h-16 w-16 rounded-2xl bg-red-600/15 border border-red-600/30 flex items-center justify-center">
          <Globe className="h-8 w-8 text-red-400" />
        </div>
        <h1 className="font-heading text-3xl font-extrabold text-white mt-6">Not available in your region</h1>
        <p className="text-zinc-400 mt-3 leading-relaxed">
          Access to UC Engineer Pro is restricted in your location and cannot be provided at this time. If you believe this is a mistake, please contact support.
        </p>
        <div className="mt-6 flex items-center justify-center gap-2 text-[12px] text-zinc-600">
          <ShieldAlert className="h-4 w-4" /> Geographic access policy
        </div>
        <button onClick={() => navigate("/login")} className="mt-6 text-[13px] text-blue-400 hover:text-blue-300 font-medium">Try again</button>
      </div>
    </div>
  );
}
